import request from "@/utils/request";



export function requestChangePicture(
  file, comment
) {
  let fileName = file == null ? "" : file.name;
  var fmData = new FormData();

  fmData.append("Comment", comment);
  fmData.append("image", file);
  fmData.append("fileName", fileName);


  return request({
    url: "picture/save",
    method: "post",
    data: fmData,
  });
}
export function getChangePictureHistory() {
  return request({
    url: "picture/gethistory",
    method: "post",
  });
}

export function removeChangePictureRequest(requestID) {
  return request({
    url: "picture/remove",
    method: "post",
    data: {
      requestID: requestID,

    },
  });
}


